import {Component, Property} from '@wonderlandengine/api';

export class PlaySoundOnClick extends Component {
    static TypeName = 'play-sound-on-click';

    static Properties = {
        soundObject: Property.object(), // Objekt mit audio-source
    };

    start() {
        const target = this.object.getComponent('cursor-target');
        target.addClickFunction(this.onClick.bind(this));
    }

    onClick() {
        if (!this.soundObject) return;

        const audio = this.soundObject.getComponent('howler-audio-source');
        if (audio) audio.play(); // MP3 starten
    }
}